import { ActionsHandler } from "../../../../ActionsHandler";
import { useDebounce } from "../../../../../hooks";
import { usePaymentDetails } from "../../hooks/usePaymentDetails";
import React, { useState } from "react";
import { ApiErrors, IStateModel } from "@nf/common";

type TActionsHandlerWrapperProps = {
  children: JSX.Element;
};

type TInitialState = {
  apiErrors: ApiErrors;
  setApiErrors: (apiErrors: ApiErrors) => void;
  isFormSent: boolean;
  setIsFormSent: (isFormSent: boolean) => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const empty = () => {};

const initialState: TInitialState = {
  apiErrors: {} as ApiErrors,
  setApiErrors: empty,
  isFormSent: false,
  setIsFormSent: empty,
};

const PaymentDetailsContext = React.createContext(initialState);
export const usePaymentDetailsContext = () =>
  React.useContext(PaymentDetailsContext);

export const ActionsHandlerWrapper: React.FC<TActionsHandlerWrapperProps> = ({
  children,
}) => {
  const [apiErrors, setApiErrors] = useState<ApiErrors>(initialState.apiErrors);
  const [isFormSent, setIsFormSent] = useState(initialState.isFormSent);

  const {
    currentOffer,
    isPaymentDetailsLoading,
    paymentError,
    subscriptions,
    isSubscriptionLoading,
  } = usePaymentDetails();

  const offerId = subscriptions?.[0]?.OfferId as string;
  const isProcessing =
    (currentOffer && offerId && (currentOffer as IStateModel)?.IsProcessing) ||
    false;
  const hasError =
    (currentOffer && offerId && (currentOffer as IStateModel).Error) || false;

  const isPaymentOfferLoading =
    currentOffer && subscriptions && subscriptions[0] && isProcessing;

  const paymentOfferError =
    currentOffer && subscriptions && subscriptions[0] && hasError;

  const userHasSubscription = !!subscriptions?.length;

  const isLoading = useDebounce<boolean | undefined>(
    isPaymentDetailsLoading ||
      isPaymentOfferLoading ||
      (!userHasSubscription && isSubscriptionLoading),
    1000
  );

  return (
    <PaymentDetailsContext.Provider
      value={{ apiErrors, setApiErrors, isFormSent, setIsFormSent }}
    >
      <ActionsHandler
        centeredError
        isLoading={isLoading}
        error={paymentOfferError || paymentError}
      >
        {children}
      </ActionsHandler>
    </PaymentDetailsContext.Provider>
  );
};
